/* eslint-disable no-empty */
import { getSessionToken } from './auth';
import { LuftHttpError } from './error';

export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const API_URL_V1 = `${API_BASE_URL}/v1`

const UNAUTHORIZED_ERROR_MESSAGE = 'Não autorizado';

function _objToParams(obj) {
  if (!obj) return '';

  return `?${Object.keys(obj)
    .filter(
      key =>
        obj[key] !== '' &&
        (!Array.isArray(obj[key]) || typeof obj[key][0] !== 'undefined'), // remove empty strings and arrays
    )
    .map(key =>
      Array.isArray(obj[key])
        ? `${key}=${encodeURIComponent(obj[key].join(','))}`
        : `${key}=${encodeURIComponent(obj[key])}`,
    )
    .join('&')}`;
}

function _readNotifications(notif) {
  if (!notif || typeof notif[0] === 'undefined') return null;
  return notif.reduce(
    (result, cur) =>
      `${result}${cur.value}${cur.value.endsWith('.') ? '' : '.'} `,
    '',
  );
}

async function _extractJson(response) {
  const contentType = response.headers.get('content-type');
  return contentType && contentType.includes('application/json')
    ? response.json()
    : {};
}

async function _extractText(response, expectedContentFile) {
  const contentType = response.headers.get('content-type');

  return contentType && contentType.includes(expectedContentFile)
    ? response.text()
    : '';
}

export const luftFetch = async ({
  endpoint,
  config,
  useSessionToken = true,
  authToken,
  isFormData = false,
  contentType = 'application/json',
  toExtractText = false,
}) => {
  if (useSessionToken && !getSessionToken()) {
    // logout
    throw new LuftHttpError(401, UNAUTHORIZED_ERROR_MESSAGE);
  }

  const fetchConfig = {
    ...config,
    headers: new Headers({
      ...(useSessionToken || authToken
        ? {
            Authorization: `Bearer ${
              useSessionToken ? getSessionToken() : authToken
            }`,
          }
        : {}),
      ...(isFormData ? {} : { 'Content-Type': contentType }),
    }),
  };

  let response = {};

  try {
    response = await fetch(endpoint, fetchConfig);
  } catch (error) {
    throw new Error(`${response.status} - ${response.statusText}`);
  }

  let responseFormat = {};
  try {
    responseFormat = toExtractText
      ? await _extractText(response, contentType)
      : await _extractJson(response);
  } catch (error) {}

  if (!response.ok) {
    if (contentType.includes('application/json')) {
      const notificationText = _readNotifications(responseFormat.notifications);
      const error = new LuftHttpError(
        response.status,
        notificationText || response.statusText || response.status,
      );
      error.responseBody = responseFormat;
      throw error;
    }

    const error = new LuftHttpError(
      response.status,
      response.statusText || response.status,
    );
    error.responseBody = responseFormat;
    throw error;
  }

  if (!toExtractText && !responseFormat.success) {
    const error = new Error('Erro response.success FALSE');
    error.responseBody = responseFormat;
    throw error;
  }

  return responseFormat;
};

// GET
export const luftGet = (endpoint, params, useSessionToken, authToken) =>
  luftFetch({
    endpoint: API_URL_V1 + endpoint + _objToParams(params),
    config: { method: 'GET' },
    contentType: 'application/json',
    useSessionToken,
    authToken,
  });

export const luftPost = (
  endpoint,
  requestBody,
  isFormData,
  useSessionToken,
  authToken,
) =>
  luftFetch({
    endpoint: API_URL_V1 + endpoint,
    config: {
      method: 'POST',
      body: isFormData
        ? requestBody
        : requestBody
        ? JSON.stringify(requestBody)
        : null,
    },
    isFormData,
    useSessionToken,
    authToken,
  });


export const luftPut = (
  endpoint,
  requestBody,
  isFormData,
  useSessionToken,
  authToken,
) =>
  luftFetch({
    endpoint: API_URL_V1 + endpoint,
    config: {
      method: 'PUT',
      body: isFormData
        ? requestBody
        : requestBody
        ? JSON.stringify(requestBody)
        : null,
    },
    contentType: 'application/json',
    isFormData,
    useSessionToken,
    authToken,
  });

export const luftDelete = (
  endpoint,
  params,
  useSessionToken = true,
  authToken,
) =>
  luftFetch({
    endpoint: API_URL_V1 + endpoint + _objToParams(params),
    config: { method: 'DELETE' },
    contentType: 'application/json',
    useSessionToken,
    authToken,
  });

export const luftDownload = (
  endpoint,
  params,
  contentType = 'text/csv',
  useSessionToken,
  authToken,
) =>
  luftFetch({
    endpoint: API_URL_V1 + endpoint + _objToParams(params),
    config: { method: 'GET' },
    contentType,
    useSessionToken,
    authToken,
    toExtractText: true,
  });
